'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BackdropStyled = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  theme: _propTypes2.default.object
};

var baseProps = function baseProps(_ref) {
  var themeFromProvider = _ref.theme;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var margin = theme.reactackle.components.dialog.window.margin;
  var _theme$reactackle$com = theme.reactackle.components.dialog.backdrop,
      backgroundColor = _theme$reactackle$com.backgroundColor,
      zIndex = _theme$reactackle$com.zIndex;


  return '\n    padding: ' + (0, _reactackleCore.getValueString)(margin) + ';\n    z-index: ' + zIndex + ';\n    background-color: ' + backgroundColor + ';\n    animation: ' + _reactackleCore.animations.fadeIn + ' 300ms ease-in;\n  ';
};

var BackdropStyled = exports.BackdropStyled = _styledComponents2.default.div.withConfig({
  displayName: 'BackdropStyled'
})(['display:block;width:100%;height:100%;position:fixed;top:0;left:0;', ';'], baseProps);

BackdropStyled.propTypes = propTypes;
BackdropStyled.displayName = 'BackdropStyled';


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-dialog/dist/styles/BackdropStyled.js
// module id = 664
// module chunks = 0